import { EnquiryModel } from '@core/models';

export class SendMessageAction {
  static readonly type = '[Contact] Send Message';
  constructor(public payload: { contact: EnquiryModel }) { }
}

export class SendMessageSuccessAction {
  static readonly type = '[Contact] Send Message Success';
}

export class SendMessageFailAction {
  static readonly type = '[Contact] Send Message Fail';
}
